<template>
	<ShareButton
		:classes="{'twitter-button': true}"
		:link="link"
		platform="X"
	>
		<template #icon>
			<Icon
				icon-name="logo-x"
				size="lg"
			/>
		</template>
	</ShareButton>
</template>

<script>
import ShareButton from './ShareButton';
import Icon from '@components/Icon';

export default {
	name:       'TwitterShareButton',
	components: { ShareButton, Icon },
	props:      {
		link: {
			type:     String,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

$blue-x: #000000;

.twitter-button::v-deep {
	color: var(--color-soft-white);
	background-color: $blue-x;
	border-color: $blue-x;
}
</style>
